import IconButton from "components/atoms/button/IconButton";
import Form from "components/atoms/form/Form";
import { Check3Icon, CheckIcon } from "components/atoms/icon/export";
import Icon from "components/atoms/icon/Icon";
import Check4Icon from "components/atoms/icon/icon-type/Check4Icon";
import LoadingScreen from "components/atoms/loading-screen/LoadingScreen";
import { customStyles } from "lib/helpers/configs/customStyles";
import { IconType } from "lib/helpers/constants/iconTypes";
import { useLeadersAndUsersByPermission } from "lib/hooks/queries/User/useLeadersAndUsersByPermission";
import { FC, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CreatableSelect from "react-select/creatable";

export interface IProps {
  setCurrentStep: (args: number) => void;
  onUpdateData: (step:number,updatedData: any) => void;
}


const Step3: FC<IProps> = ({ setCurrentStep, onUpdateData }) => {
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    reset,

  } = useForm()


  const { data, isLoading } = useLeadersAndUsersByPermission({
    permissions_for_assign: 'assign_assigned_leads_assign',
    permissions_for_assigment: 'leads_assigment_assign',
  })

  const fetchedUsers = useMemo(() => {
    if (!data) return [];

    const leadersOrAdmins = (data as any).usersInTeamAsLeadersOrAdmin.map((user: any) => ({
      label: user.name + " " + user.last_name + " (" + user.team_name + '/' + user.in_team + ")",
      value: user.id,
      team: user.team_name,
    }));

    const users = (data as any).usersExpectLeadersOrAdmin.map((user: any) => ({
      label: user.name + " " + user.last_name,
      value: user.id,
    }));

    return [...leadersOrAdmins, ...users];

  }, [data])

  const onSubmit = async (data: Record<string, any>): Promise<void> => {
    const FullUser = fetchedUsers.find((user: any) => user.value === data.user);

    if (FullUser) {
      onUpdateData(4,{ assign_to: { id: FullUser.value, in_team: FullUser?.team || null } })
    }

    setCurrentStep(4);
  };

  return (
    <Form
      onSubmit={handleSubmit(onSubmit)}
      className="mb-0 flex flex-col pl-4 pb-2"
    >

      <div className="border-l-[1.5px] border-dashed border-[#D8D8D8] pl-7 pb-9 relative bg-transparent">
        <div className="pl-2 text-[14px] font-inter-medium pb-5">
          {t('Upload CSV')}
        </div>
        <div className="absolute top-[0] left-[-12px] z-9999">
          <CheckIcon color={'var(--theme)'} />
        </div>
      </div>

      <div className="border-l-[1.5px] border-dashed border-[#D8D8D8] pl-7 pb-9 relative bg-transparent">
        <div className="pl-2 text-[14px] font-inter-medium pb-5 ">
          {t('Only adjust the fields you want to import')}
        </div>

        <div className="absolute top-[0] left-[-12px] z-9999 ">
          <CheckIcon color={'var(--theme)'} />
        </div>
      </div>

      <div className="border-l-[1.5px] border-dashed border-[#D8D8D8] pl-7 pb-9 relative bg-transparent">
        <div className="pl-2 text-[14px] font-inter-medium pb-5">
          {t('Assign the leads to a worker')}
        </div>
        <div className="relative">

          {isLoading && (
            <div className="py-20">
              <LoadingScreen />
            </div>
          )}
          <div
            className="rounded-[20px] p-4 w-full bg-themeOpacity2"
          >
            <Controller
              name="user"
              control={control}
              render={({ field }) => (
                <CreatableSelect<any, false>
                  {...field}
                  placeholder={t("Users")}
                  options={fetchedUsers}
                  value={
                    field?.value
                      ? {
                        value: field?.value,
                        label: (fetchedUsers?.find?.(
                          (user: any) => user.value === field.value
                        ) as { label: string } | undefined
                        )?.label,
                      }
                      : null
                  }
                  className="cursor-pointer font-inter-regular react-select-container max-w-[400px]"
                  classNamePrefix="react-select"
                  onChange={(newValue: any, actionMeta: any) => {
                    if (
                      actionMeta.action === "select-option" &&
                      newValue?.value
                    ) {
                      field.onChange(newValue.value);
                    }
                  }}
                  styles={customStyles}
                  isValidNewOption={() => false}
                  menuPosition={"fixed"}
                  menuPortalTarget={document.body}
                />
              )}
            />
            <div className="flex items-center gap-2 mt-4">
              <Icon iconType={IconType.ALERT_ICON} color={'var(--theme)'} />
              <span className="font-inter-medium text-[13px] text-primaryTextColor">
                {t('If no one is selected these leads will remain unassigned')}.
              </span>
            </div>
          </div>
        </div>

        <div className="absolute top-[0] left-[-12px] z-9999 ">
          <Check3Icon color={'var(--theme)'} />
        </div>
      </div>
      <div className="pl-7 relative bg-transparent">
        <div className="pl-2 text-[14px] font-inter-medium pb-5 opacity-40">
          {t("Remove the leads here that you don't want to import")}
        </div>

        <div className="absolute top-[0] left-[-12px] z-9999 ">
          <Check4Icon className="opacity-40" color={'var(--theme)'} />
        </div>
      </div>
      {/* Buttons */}
      <div className="flex gap-5 justify-end">
        <IconButton
          type="button"
          onClick={() => { reset() }}
          secondary={true}
          className="w-full max-w-[150px]"
        >
          {t('Reset')}
        </IconButton>
        <IconButton
          icon={<Icon iconType={IconType.UPLOAD_FILE_ICON} />}
          className="w-full max-w-[150px]"
        >
          {t("Continue")}
        </IconButton>
      </div>
    </Form>
  );
};

export default Step3;
